exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title[data-v-579d411c]{font-weight:600}.wrapper[data-v-579d411c]{min-height:500px}@media screen and (max-width:1024px){.wrapper[data-v-579d411c]{min-height:100px}}", ""]);

